import { VenueDoc } from 'Shared/model/venue';
import { isServer } from 'solid-js/web';

export function title(venue:VenueDoc,pageDisplayName?:string)
{
	const vite = !isServer && window.useVite ? '🎸DEV ' : '';
	const pageName = pageDisplayName ? pageDisplayName + ' @ ' : '';
	const venueName = venue.nickname ?? venue.name;

	return vite + pageName + venueName;
}

